var locales = require('./locales.json')
var template = require('./index.html')
var t = require('../translate')
var config = require('app-config');
var RuneSetOrder = require('../runes-set-order')

module.exports = {
  data: data,
  template: template,
  components: {
    'app-header': { template: require('./header.html'), components: {'app-logo': require('../logo')} },
    'app-footer': require('../footer'),
    'app-shops': require('../shops'),
    'app-runes-set-order': RuneSetOrder,    
    'app-video-modal': require('./video-modal.js')
  },
  computed: {
    url1: function() { return this.home_url+"/die-halle-der-runen-karten";}
  },
  methods: {
    t: function(v) {
      return t(locales, v);
    },
    showVideoModal() {
      console.log("this.showModal")
      this.showModal = true;
    }
  }
}

function data () {
  return {
    showModal: false,
    home_url: config.home_url,
    desc: require('../home-view/hallofrunes_desc.html'),
    country_items: [
      {text: 'Schweiz', value: 'ch'},
      {text: 'Lichtenstein', value: 'li'}
    ]
  }
}


// WEBPACK FOOTER //
// ./lib/runeset-view/index.js